<template>
  <div class="china-box">
    <svg :width="width" :height="height" >
      <g id="china"></g>
    </svg>
    <div v-for="(item,$index) in dots"
         :key="$index"
         class="city-point"
         @mouseover="onShow(this, item.index)"
         @mouseout="onHide(this, item.index)"
         :style="{ left: item.left+'px', top: item.top+'px' }">
      <span class="d d1"></span>
      <span class="d d2"></span>
    </div>
    <div class="display-text-box text-left" :class="{ 'box-hide': boxHide}">
      <div class="fadeIn" v-for="(item, $index) in showUcs" :key="$index">
        <p class="normal-lineheight" style="font-size: 24px;font-weight: bold;">{{item.name}}</p>
        <p class="normal-lineheight" style="font-size: 18px;">
          <span>地址：</span>
          <span v-for="(i,$i) in getUcsText(item.address)" :key="$index*100 + $i">{{i}}<br/></span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import * as d3 from 'd3'
  import axios from 'axios'

  export default {
    props: {
      width: [Number],
      height: [Number]
    },
    data() {
      return {
        projection: d3.geoMercator().center([107,38]).scale(800).translate([this.width / 2, this.height / 2]),
        dots:[

        ],
        showUcs:[

        ],
        boxHide: true,
        locations:[
          {
            city: '上海',
            id: 27,
            coord:[121.485435, 31.208797],
            ucss:[
              { name: '上海巨鹿店', address: '上海市黄浦区蒙自路382号' }
            ],
          },
          {
            city: '成都',
            id: 18,
            coord: [104.129339, 30.615519],
            ucss:[
              { name: '四川师范大学店', address: '四川省成都市锦江区静安路5号四川师范大学内' }
            ]
          },
          {
            city: '乐山',
            id: 18,
            coord: [103.759317,29.599182],
            ucss:[
              { name: '四川乐山店', address: '四川省乐山市市中区春华路中段175号' }
            ]
          },
          {
            city: '淄博',
            id: 0,
            coord: [118.067564,36.853851],
            ucss:[
              { name: '山东金弘无人酒庄', address: '山东省淄博市高新区汇金大厦A座2305室' }
            ]
          },
          {
            city: '杭州',
            id: 28,
            coord: [120.125999, 30.314631],
            ucss:[
              { name: '杭州蓝钻天成店', address: '浙江省杭州市拱墅区莫干山路969号蓝钻天成中健银座健身房斜对面' },
              { name: '杭州氧气公寓店', address: '浙江省杭州市上城区城头巷109号氧气公寓1楼大厅内' },
            ]
          },
          {
            city: '金华',
            id: 0,
            coord: [119.653425, 29.098043],
            ucss:[
              { name: '金华九菜店', address: '金华市银海湾小区（老农贸）' },
            ]
          },
          {
            city: '南京',
            id: 0,
            coord: [118.751087, 31.943312],
            ucss:[
              { name: '南京体验店', address: '江苏省南京市雨花台区大周路88号中国（南京）软件谷D2栋1304室' }
            ]
          },
          {
            city: '廊坊',
            coord: [116.710209, 39.524273],
            ucss:[
              { name: '河北廊坊日报店', address: '河北省廊坊市广阳区文明路18号廊坊日报社读者俱乐部内' }
            ]
          },
          {
            city: '常州',
            coord: [119.981651, 31.837365],
            ucss:[
              { name: '常州瑞和泰店', address: '江苏省常州市新北区汉江中路368号' }
            ]
          },
          {
            city: '江西',
            coord: [115.864551, 28.688671],
            ucss:[
              { name: '江西南昌店', address: '江西省南昌市新建区学府大道219号新华书店内' }
            ]
          },
          {
            city: '山西',
            coord: [113.123795, 36.201042],
            ucss: [
              { name: '山西长治店', address: '山西省长治市城区解放东路340号' }
            ]
          }
        ]
      }
    },
    created() {
      var j = d3.json('/static/geo/china.geo.json').then((root)=> {

        this.loadLocations()
          .then((response)=> {
            this.drawMap(root, response.data.provinces);

            this.drawPoints(response.data.locations);
          })

      }).catch((e)=>{console.log(e)})
    },
    mounted() {

    },
    methods: {
      loadLocations(){
        return axios.get('/static/geo/ucs_location.json')
      },
      drawMap(root, provinces) {

        var path = d3.geoPath().projection(this.projection)

        d3.select('#china')
          .selectAll('path')
          .data(root.features)
          .enter()
          .append('path')
          .attr('d', path)
          .attr('stroke', '#E83518')
          .attr('stroke-width', '1')
          .attr('fill', function(d, i){
            if(provinces.indexOf(d.properties.name) !== -1)
              return "#FFA798";
            else return '#FEF5F4';
          })
      },
      drawPoints(locations){
        for(var locIndex in locations){
          const loc = this.projection(locations[locIndex].coord);

          this.dots.push({
            index: locIndex,
            left: loc[0]-15,
            top: loc[1]-15
          })
        }

      },
      //超过12个字符分隔到下一行
      getUcsText(text){
        if(!text) return;

        var maxLen = 12;

        var currText = text;
        if(currText.length <= maxLen) return [text];

        var texts = [];

        var curr = 0;
        while(currText.length > maxLen) {

          texts.push(currText.substring(curr, maxLen));

          currText = currText.substring(curr + maxLen);
        }
        if(currText)
          texts.push(currText)

        return texts;
      },
      onShow(dom, index){
        this.boxHide = false;
        this.showUcs = {
          ...this.locations[index].ucss
        };
      },
      onHide(dom, index){
        this.showUcs = [];
        this.boxHide = true;
      }
    }
  }
</script>

<style>
  .box-hide{
    visibility: hidden;
  }

  .china-box {
    width: 100%;
    position: relative;
    color: #FF2A00;
    box-sizing: border-box;
  }

  .display-text-box {
    width: 330px;
    position: absolute;
    top: 400px;
    left: 1300px;
    border: 1px solid #FF2A00;
    display: inline;
    padding: 16px;
  }

  .display-text-box p {
    padding-left: 18px;
    line-height: 16px;
    position: relative;
    font-size: 12px;
    margin: 0;
  }

  .city-point {
    width: 30px;
    height: 30px;
    position: absolute;
    z-index: 10;
  }

  .city-point .d {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 6px;
    height: 6px;
    box-sizing: border-box;
    border: 1px solid #FF2A00;
    border-radius: 50%;
  }

  .city-point .d1{
    background-color: #FF2A00;
  }

  .city-point .d2{
    animation: disperse 1.25s linear infinite;
  }

  @keyframes disperse {
    from{
      width: 6px;
      height: 6px;
      opacity: 1;
    }
    to{
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }

  .fadeIn {
    animation: fadeIn 1s ease-in;
  }
</style>



// WEBPACK FOOTER //
// src/components/China.vue